import Navbar from '../components/Navbar.js';
import EmpackPresentation from '../components/EmpackPresentation.js';
import './PresentationView.css';

const PresentationView = () => {

    return (
        <div className="PresentationView">
            <Navbar />
            <EmpackPresentation />
        </div>
    )
}

export default PresentationView;